import { Box,Button,Flex,Select,InputGroup,
  InputLeftElement,Input, Heading, Text, Switch,
  TableContainer,Table,Thead,Tbody,Th,Tr,Td, Grid, GridItem, Checkbox,  } from "@chakra-ui/react";
import { SearchForm, TopDisplay, TablePopUp, DateFilter} from "../../../../components";
import { IoMdAdd as AddIcon } from "react-icons/io";
import { LuSearch as SearchIcon } from "react-icons/lu";
import { useState,useEffect } from "react";
import styled from "@emotion/styled";
import {TopLink} from '../';
import { FaRegTrashAlt as DeleteIcon } from "react-icons/fa";
import {openAtom,modalAtom, openNAtom, notificationAtom} from '../../../../context';
import { atom, useAtom } from 'jotai';
import { Formik,Form,Field } from "formik";
import { MdMoreVert as MoreIcon } from "react-icons/md";
import ViewSetting from '../Modal/ViewSetting';
import apiCall from '../../../../utils/apiCall';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { format, setDate } from "date-fns";
import * as Yup from 'yup';
import moment from "moment";
import { Loader } from "../../../../customs";
import { TbReload as ReloadIcon } from "react-icons/tb";
import ReactPaginate from 'react-paginate';
import { IoReloadCircleOutline as ResetIcon} from "react-icons/io5"


const HeadStyle={
  borderBottom:"1px solid var(--cipm-light-green)",
  padding:'15px 5px',
  color:'var(--dark-green-color)',
}
const DataStyle = {
  padding:'5px 5px',
}


const ROWSTYLE = styled.tr`
  & > td:last-of-type > *{
    display:none;
  }
  :hover > td{
    background-color:var(--table-highlight);
    &:last-of-type > *{
      display:block;
    }
  } 
  &.active > td:last-of-type > *{
    display:block !important;
  }  
`
const examPeriodAtom = atom<number | null>(null);

export default function ExamPeriod() {
  const [hide,set_hide] = useState<boolean>(true);
  const [active] = useAtom<number | string | null>(examPeriodAtom);
  const [,set_open] = useAtom(openAtom);
  const [,set_modal] = useAtom(modalAtom);
  const [filter_data,set_filter_data] = useState<any>([])


  const {isLoading,data:examPeriods} = useQuery(["exam-period"],{
    queryFn: async ()=> await apiCall().get(`/exam/setup/examPeriod`),
    select: (data) => data?.data?.Data,
    onSuccess(data) {
        console.log(data,'exam period data')
    },
  })
  const [search,set_search] = useState('');
  const handleSearch = (e:any)=>{
    let val = e.target.value;
    set_search(val);
    if(val){
      let new_data = filter_data?.filter((eData:any) => Object.values(eData).join(examPeriods).toLowerCase().includes(val.toLowerCase()) );
      if(new_data.length > 0)set_filter_data(new_data)
      else set_filter_data('')
    }
    else set_filter_data(examPeriods)
  }


  const handleAddExam = () =>{
      set_modal({
        header:'Exam Period(Diet) Setup',
        content:<AddType />
      })
      set_open(true);
  }
  
  const itemsPerPage = 10;
const [itemOffset, setItemOffset] = useState(0);
const endOffset = itemOffset + itemsPerPage;
console.log(`Loading items from ${itemOffset} to ${endOffset}`);
const currentItems = filter_data?.slice(itemOffset, endOffset);
const pageCount = Math.ceil(filter_data?.length / itemsPerPage);
const handlePageClick = (event:any) => {
  const newOffset = (event.selected * itemsPerPage) % filter_data?.length;
  console.log(
    `User requested page number ${event.selected}, which is offset ${newOffset}`
  );
  setItemOffset(newOffset);
};

const handleDateFilter = (obj:any) =>{
  const {start,end} = obj; 
  //console.log(obj,'start end');
  const s_date:number = new Date(start.concat("T00:00:00") || null)?.getTime();
  const e_date:number = new Date(end.concat("T00:00:00") || null)?.getTime();
  //console.log(s_date,e_date,'date in seconds')
  const tempData:any = examPeriods;
  let f_data = tempData.filter((eData:any)=>{
    let e_date_time:number = new Date(eData?.ExamDateTime?.split('.')[0] || null)?.getTime();
    //console.log(e_date_time,'time in seconds')
    return e_date_time >= s_date && e_date_time <= e_date;
  })
 // console.log(f_data,'date filtered data')
  if(f_data.length > 0)set_filter_data(f_data);
  else set_filter_data(examPeriods);
}
useEffect(()=>{
  set_filter_data(examPeriods)
},[examPeriods])
   
  return (
    <>
      {isLoading?<Loader />:

    <Box>
      <TopLink />
      <TopDisplay label="Exam Period(Diet)" button_array={[
          <Button onClick={handleAddExam} bg="var(--dark-green-color)" color="var(--white-color)"  type="button" leftIcon={<AddIcon/>}>Add Exam Period(Diet)</Button>
        ]} />
        <Flex  gap="20px" wrap="wrap" mt="20px">
          <InputGroup width="250px" bg="var(--white-color)" borderColor="var(--dark-green-color)">
            <InputLeftElement pointerEvents='none'>
              <SearchIcon color='gray.300' />
            </InputLeftElement>
            <Input value={search} onChange={handleSearch} type='text' placeholder='search' />
          <span style={{position:'absolute',zIndex:'1',
          right:'10px',cursor:'pointer',top:'12px'}}><ReloadIcon /></span>
          </InputGroup>
          <DateFilter onChange = {handleDateFilter}/>
        <Button onClick={()=>{set_filter_data(examPeriods);set_search('')}} bg="var(--dark-green-color)" color="var(--white-color)"  type="button"  leftIcon={<ResetIcon/>}>Reset Filter</Button>

          {/* <Select placeholder="Date Range" width="150px" bg="var(--white-color)" 
            borderColor="var(dark-green-color)">
          </Select> */}
          

        </Flex>
        <Flex mt="25px" flexDir="column" gap="10px">
          {/* <Heading m="0" fontSize="1rem">All Candidates</Heading> */}
          <Text m="0" fontSize=".8rem">showing {itemOffset} - {itemOffset + itemsPerPage > filter_data?.length?filter_data?.length:endOffset} of {filter_data?.length}</Text>
        </Flex>
      
     {  filter_data && filter_data.length  > 0 ? <TableContainer sx={{overflowY:'visible',h:'max-content'}}  mt="20px">
          <Table sx={{overflowY:'visible'}} size='sm'>
            <Thead>
              <Tr >
                {/* <Th sx={HeadStyle}>Exam ID</Th> */}
                <Th sx={HeadStyle}>Exam(Diet)</Th>
                <Th sx={HeadStyle}>Exam(Diet) Start</Th>
                <Th sx={HeadStyle}>Exam(Diet) End</Th>
                <Th sx={HeadStyle}>Late Registration</Th>
                <Th sx={HeadStyle}>Late Fee</Th>
                <Th sx={HeadStyle}>Exam Start</Th>
                <Th sx={HeadStyle}>Exam End</Th>
                <Th sx={HeadStyle} w="50px"></Th>
              </Tr>
            </Thead>
            <Tbody sx={{overflowY:'visible'}}>
              {currentItems.map((eExamperiod:any,_index:number) =><ROWSTYLE className={eExamperiod.Id === active?'active':''} key={eExamperiod.Id}>
                {/* <Td sx={DataStyle}>{eExamperiod.Id}</Td> */}
                <Td sx={DataStyle}>{eExamperiod.ExamName}</Td>
                <Td sx={DataStyle}>
                    {format(new Date(eExamperiod.StartDate), "dd/MM/yyyy")}<br />
                    {format(new Date(eExamperiod.StartDate), "hh:mm a")}</Td>                
                    <Td sx={DataStyle}>{format(new Date(eExamperiod.EndDate), "dd/MM/yyyy")}<br />
                    {format(new Date(eExamperiod.EndDate),"hh:mm a")}</Td>
                <Td sx={DataStyle}>{`${format(new Date(eExamperiod.LateRegistrationStartDate), "dd/MM/yyyy")} - ${format(new Date(eExamperiod.LateRegistrationEndDate), "dd/MM/yyyy")}`}</Td>
                <Td sx={DataStyle}>{eExamperiod.LateRegistrationFee}</Td> 
                <Td sx={DataStyle}>{format(new Date(eExamperiod.ExamStartDate), "dd/MM/yyyy")} <br />
                {format(new Date(eExamperiod.ExamStartDate), "hh:mm a")}</Td>
                <Td sx={DataStyle}>{format(new Date(eExamperiod.ExamEndDate), "dd/MM/yyyy")} <br />
                {format(new Date(eExamperiod.ExamEndDate), "hh:mm a")} </Td>                
                <Td sx={DataStyle} w="50px" h="50px">
                  <TempPopUp index={eExamperiod.Id} data={eExamperiod}/>
                </Td>
              </ROWSTYLE>
              )}
            </Tbody>
          </Table>
        </TableContainer>
        :'No Exam period'  
      }
      <StylePaginateBox>
      <ReactPaginate
        breakLabel="..."
        nextLabel=">"
        onPageChange={handlePageClick}
        pageRangeDisplayed={5}
        pageCount={pageCount}
        previousLabel="<"
        renderOnZeroPageCount={null}
      />

    </StylePaginateBox>

    </Box>
}
  </>
  )
}
const StylePaginateBox = styled.div`
width:100%;
& > ul{
  list-style-type: none;
  text-align:center;
  padding:0;
  margin:0;
  margin-top:10px;
} 
& > ul > li{
  display: inline;
  margin:0 5px;
  padding:2px 5px;
  border-radius: 3px;
  background-color: transparent;
  color:var(--dark-green-color);
}
& > ul > li.selected{
  background-color: var(--highlight-paginate-background);
  color:var(--highlight-paginate-color);
}
& > ul > li:first-of-type,
& > ul > li:last-of-type{
  font-weight: bold;
}
`
  
const AddSchema = Yup.object({
  ExamName:Yup.string().required(),
  StartDate: Yup.date().required(),
  EndDate: Yup.date().required(),
  LateRegistrationStartDate:Yup.date().required(),
  LateRegistrationEndDate: Yup.date().required(),
  ExamStartDate: Yup.date().required(),
  ExamEndDate: Yup.date().required(),
  IsFlexible:Yup.bool(),
  LateRegistrationFee:Yup.number().required(),
  FlexibleDateStart:Yup.date(),
  FlexibleDateEnd:Yup.date(),
});

const Label = styled.label``;  

const AddType = (props:any = {}) =>{
  console.log({...props},'data')
  let isEdit = props?.isEdit ?true : false;
  const queryClient = useQueryClient();
  const [,set_open] = useAtom(openAtom);
  const [,set_N_open] = useAtom(openNAtom);
  const [,set_notification] = useAtom(notificationAtom);


  const {mutate:addUpdate,isLoading} = useMutation({
    mutationKey:['new-exam-period'],

    mutationFn:async (payload:any)=> {
      //console.log(props.Id,'Id')
      return props && props.Id?await apiCall().put(`/exam/setup/examPeriod/${props.Id}`,payload):await apiCall().post(`/exam/setup/examPeriod`,payload).then(async (data:any)=>{
        //console.log(data,'data')
        set_open(false);
        set_notification({
          type:'success',
          message: data?.Message || data?.data?.Message || isEdit == true ?'Edited Successfully': 'Added Successfully'
        })
        set_N_open(true);
        queryClient.invalidateQueries({
          queryKey:['exam-period']
        })
      })},
    onSuccess:(data:any)=>{
      //console.log(data,props.Id,'data')
      set_notification({
        type:'success',
        message: data?.Message || data?.Data?.Message || isEdit == true ?'Edited Successfully': 'Added Successfully'
      })
      set_N_open(true);
      queryClient.invalidateQueries({
        queryKey:['exam-period']
      })
    },
    onError(error:any){
      set_notification({
        type:'error',
        message:error?.response?.data?.Message || 'Error Occured'
      })
      set_N_open(true);
    },
    onSettled:()=>{
      set_open(false);
    }
  } )
  return (
    <>
      <Formik
          initialValues={{
            ExamName:props.ExamName || '',
            StartDate:props.StartDate || '',
            EndDate:props.EndDate || '',
            LateRegistrationStartDate:props.LateRegistrationStartDate || '',
            LateRegistrationEndDate:props.LateRegistrationEndDate || '',
            LateRegistrationFee:props.LateRegistrationFee || '',
            ExamStartDate:props.ExamStartDate || '',
            ExamEndDate:props.ExamEndDate || '',
            FlexibleDateStart:props.FlexibleDateStart || '',
            FlexibleDateEnd:props.FlexibleDateEnd || '',
            IsFlexible:props.IsFlexible?true: false,
          }}
          validationSchema={AddSchema}
          // validateOnChange={true}
          onSubmit={(values:any) => {
            const data:any = {
              ExamName:values.ExamName,
              StartDate:values.StartDate,
              EndDate:values.EndDate,
              LateRegistrationStartDate:values.LateRegistrationStartDate,
              LateRegistrationEndDate:values.LateRegistrationEndDate,
              LateRegistrationFee:values.LateRegistrationFee,
              ExamStartDate:values.ExamStartDate,
              ExamEndDate:values.ExamEndDate,
              IsFlexible:values.IsFlexible,
            };
            if(values.IsFlexible){
              data.FlexibleDateStart = values.FlexibleDateStart;
              data.FlexibleDateEnd = values.FlexibleDateEnd;
            }
            //console.log(data,'form data')

            addUpdate(data);
          }}
        >
         {(formik:any)=>{
        const {values,errors} = formik;
        
          if(values.StartDate || values.EndDate){
            let tStart = new Date(values.StartDate ).getTime();
            let tEnd = new Date(values.EndDate ).getTime();
            let tempStart = new Date(values.LateRegistrationStartDate ).getTime();
            let tempEnd = new Date(values.LateRegistrationEndDate ).getTime();
            let examStartDate = new Date(values.ExamStartDate).getTime();
            let examEndDate = new Date(values.ExamEndDate).getTime();

            if(tStart > tEnd){
              values.EndDate = '';
              errors.EndDate = `End Date cannot be less than Start Date`
            }
            //made a modification here to reverse late registration start date to be within start and end date
            if(tempEnd < tStart || tempEnd > tEnd){
              // values.LateRegistrationEndDate = '';
              errors.LateRegistrationEndDate = `Late Registration End Date cannot be less than lateRegistration start date or greater than Exampriod End Date`;
            }
            if(tempStart < tStart || tempStart > tEnd){
              // values.LateRegistrationStartDate = '';
              errors.LateRegistrationStartDate = `Late Registration Start Date cannot be less than ExamPeriod Start or greater than ExamPeriod End Date`;
            }
            if(tempStart > tempEnd){
              // values.LateRegistrationEndDate = '';
              errors.LateRegistrationEndDate = `Late Registration Start Date cannot be greater than Late Registration End Date `
            }

            if(tStart && tEnd && examStartDate){
               if(examStartDate <= tStart || examStartDate >= tEnd){
                errors.ExamStartDate = `Exam Start Date must be after ExamPeriod StartDate and before ExamPeriod EndDate`
               }

              }
            if(tStart && tEnd && examEndDate){
               if(examEndDate <= tStart || examEndDate >= tEnd){
                errors.ExamStartDate = `Exam End Date must be after ExamStart Date and before ExamPeriod EndDate`
               }
            }
            if(tempEnd && examStartDate ){
              //console.log(examStartDate <= tempEnd,'test1')
              if(examStartDate <= tempEnd){
                errors.ExamStartDate = `ExamStartDate must be after LateRegistration EndDate`
               } 
               else{
                delete errors.ExamStartDate;
               }
            }
            if(tempEnd && examEndDate){
              console.log(tempEnd,examEndDate,'test2')
              if(examEndDate <= tempEnd){
                errors.ExamEndDate = `Exam End Date must be after  LateRegistration
                EndDate`
              }
              else{
                delete errors.ExamEndDate;
              }
            }

            if(examStartDate && examEndDate){
              if(examEndDate <= examStartDate){
                errors.ExamEndDate = `Exam End Date must be after Exam Start Date`;
              }
            }
            
            if(values.IsFlexible){
           
            //  console.log(values.FlexibleDateStart ,'flexible_start')
              let tempStart2 = new Date(values.FlexibleDateStart ).getTime();
              let tempEnd2 = new Date(values.FlexibleDateEnd ).getTime();
              if(tempStart2 > tempEnd2 || tempEnd2 > tEnd){
                values.FlexibleDateEnd = '';
                errors.FlexibleDateEnd = `Flexible End Date cannot be less than Start Date, Also Flexible End Date cannot be greater than End Date`
              }
              if(tStart > tempStart2 || tempStart2 > tEnd){
                values.FlexibleDateStart = ''
                errors.FlexibleDateStart = `Flexible Start Date cannot be less than Start Date, Also Flexible End Date cannot be greater than End Date`
              }
            
            }
           // console.log(errors,'errors')
          }
         
        
        return (
            <Form>
              <Flex maxW="650px" flexDir={"column"} align={"center"} gap="20px">
                <Input as={Field} 
                  placeholder="Exam Period Name"
                  name="ExamName"
                  type="text"
                />
                <Flex w="100%" as={Label} flexDir="column" gap="10px" >
                  <span>Exam(Diet) Start Date</span> 
                  <Input as={Field} flex="1"
                  size="md"
                  name="StartDate"
                  type="datetime-local"
                />
                </Flex>
                {
                  errors.StartDate?
                    <Box maxW="350px" color="red">
                      {errors.StartDate}
                    </Box>
                  :''
                }
                <Flex w="100%" as={Label} flexDir="column" gap="10px" >
                  <span>Exam(Diet) End Date</span> 
                  <Input as={Field}
                    size="md"
                    name="EndDate"
                    type="datetime-local"
                  />

                </Flex>
                {
                  errors.EndDate?
                    <Box maxW="100%" color="red">
                      {errors.EndDate}
                    </Box>
                  :''
                }
                <Flex w="100%" as={Label} flexDir="column" gap="10px" >
                  <span>Late Registration Start Date</span> 
                  <Input as={Field}
                    size="md"
                    name="LateRegistrationStartDate"
                    type="datetime-local"
                  />
                </Flex>
                {
                  errors.LateRegistrationStartDate?
                    <Box maxW="350px" color="red">
                      {errors.LateRegistrationStartDate}
                    </Box>
                  :''
                }
                <Flex w="100%" as={Label} flexDir="column" gap="10px" >
                  <span>Late Registration End Date</span> 
                  <Input as={Field}
                  size="md"
                  name="LateRegistrationEndDate"
                  type="datetime-local"
                />
                </Flex>
                {
                  errors.LateRegistrationEndDate?
                    <Box maxW="350px" color="red">
                      {errors.LateRegistrationEndDate}
                    </Box>
                  :''
                }
                   <Flex w="100%" as={Label} flexDir="column" gap="10px" >
                  <span>Exam Start Date</span> 
                  <Input as={Field} flex="1"
                  size="md"
                  name="ExamStartDate"
                  type="datetime-local"
                />
                </Flex>
                {
                  errors.ExamStartDate?
                    <Box maxW="350px" color="red">
                      {errors.ExamStartDate}
                    </Box>
                  :''
                }
                <Flex w="100%" as={Label} flexDir="column" gap="10px" >
                  <span>Exam End Date</span> 
                  <Input as={Field}
                    size="md"
                    name="ExamEndDate"
                    type="datetime-local"
                  />

                </Flex>
                {
                  errors.ExamEndDate?
                    <Box maxW="100%" color="red">
                      {errors.ExamEndDate}
                    </Box>
                  :''
                }
                <Flex  w="100%" as={Label} flexDir="column" gap="10px">
                <span>Late Registration Fee</span> 
                <Input as={Field} 
                  placeholder=" amount in Figures only, no comma"
                  name="LateRegistrationFee"
                  type="Numeric"
                />
                <Box color='red'>
                  {errors?.LateRegistrationFee?errors?.LateRegistrationFee:''}
                </Box>
                </Flex>
                <Field as={Checkbox}
                  size="md"
                  name="IsFlexible"
                  sx={{alignSelf:'flex-start'}}
                  isChecked={values.IsFlexible}
                >Make Flexible</Field>  
                {values.IsFlexible?<>
                <Flex w="100%" as={Label} flexDir="column" gap="10px" >
                  <span>Flexible Start Date</span> 
                  <Input as={Field}
                    size="md"
                    name="FlexibleDateStart"
                    type="datetime-local"
                  />
                </Flex>
                {
                  errors.FlexibleDateStart?
                    <Box maxW="350px" color="red">
                      {errors.FlexibleDateStart}
                    </Box>
                  :''
                }
                <Flex w="100%" as={Label} flexDir="column" gap="10px" >
                  <span>Flexible End Date</span> 
                  <Input as={Field}
                    size="md"
                    name="FlexibleDateEnd"
                    type="datetime-local"
                  />
                </Flex>
                {
                  errors.FlexibleDateEnd?
                    <Box maxW="350px" color="red">
                      {errors.FlexibleDateEnd}
                    </Box>
                  :''
                }
                </>:<></>}               
              
                {/* <Box color="red" fontSize=".7rem">
                  {errors.EndDate ?errors.EndDate:''}
                </Box> */}
                <Button type="submit" bg="var(--dark-green-color)" 
                  color="var(--white-color)" disabled={isLoading} >
                  {isLoading?"Loading":'Submit'}
                </Button>
              </Flex>
                
              
            </Form>
          )}}
        </Formik>
    </>
  )
}

const TempPopUp = (props:any) =>{
  const index = props.index;
  const data = props.data;
  const [active,set_active] = useAtom(examPeriodAtom);
  const [,set_open] = useAtom(openAtom);
  const [,set_modal] = useAtom(modalAtom);
  const queryClient = useQueryClient();
  const {mutate:deleteExam,isLoading} = useMutation({
    mutationKey:['delete-exam-period'],
    mutationFn:async () => await apiCall().get(`/exam/setup/examPeriod/${data?.Id}/delete`),
    onSuccess() {
      queryClient.invalidateQueries({queryKey:["exam-period"]})
    },
    onSettled(){
      set_open(false);
    }
  })

  const handleClick = () =>{
    if(index === active){
      set_active(null);
      return;
    }
    else{
      set_active(index);
    }
  }
  const handleView= () =>{
    set_modal({
      header:'View Exam SetUp',
      content:<Grid>
        <GridItem as={Flex} justify="space-between" p="10px 0">
          <span>Exam Period Name</span>
          <span>{data?.ExamName}</span>
        </GridItem>
        <GridItem as={Flex} justify="space-between" p="10px 0">
          <span>Exam Period Start Date</span>
          <span>{format(new Date(data?.StartDate), "dd/MM/yyyy")}<br />
          {format(new Date(data?.StartDate), "hh:mm a")}</span>
        </GridItem>
        <GridItem as={Flex} justify="space-between" p="10px 0">
          <span>Exam Period End Date</span>
          <span>{format(new Date(data?.EndDate), "dd/MM/yyyy")}
          <br />
          {format(new Date(data?.EndDate), "hh:mm a")}
          </span>
        </GridItem>
        <GridItem as={Flex} justify="space-between" p="10px 0">
          <span>Late Registration Start Date</span>
          <span>{format(new Date(data?.LateRegistrationStartDate), "dd/MM/yyyy")}<br />
          {format(new Date(data?.LateRegistrationStartDate), "hh:mm a")} </span>
        </GridItem>
        <GridItem as={Flex} justify="space-between" p="10px 0">
          <span>Late Registration End Date</span>
          <span>{format(new Date(data?.LateRegistrationEndDate), "dd/MM/yyyy")}<br />
          {format(new Date(data?.LateRegistrationEndDate), "hh:mm a")} </span>
        </GridItem>
        <GridItem as={Flex} justify="space-between" p="10px 0">
          <span>Exam Start Date</span>
          <span>{format(new Date(data?.ExamStartDate), "dd/MM/yyyy")}<br />
          {format(new Date(data?.ExamStartDate), "hh:mm a")}</span>
        </GridItem>
        <GridItem as={Flex} justify="space-between" p="10px 0">
          <span>Exam End Date</span>
          <span>{format(new Date(data?.ExamEndDate), "dd/MM/yyyy")}<br />
          {format(new Date(data?.ExamEndDate), "hh:mm a")}</span>
        </GridItem>
        <GridItem as={Flex} justify="space-between" p="10px 0">
          <span>Late Registration Fee</span>
          <span>{data?.LateRegistrationFee}</span>
        </GridItem>{
          data.IsFlexible?<>
            <GridItem as={Flex} justify="space-between" p="10px 0">
          <span>Flexible Start Date</span>
          <span>{format(new Date(data?.FlexibleDateStart), "dd/MM/yyyy")}<br />
          {format(new Date(data?.FlexibleDateStart), "hh:mm a")}</span>
        </GridItem>
        <GridItem as={Flex} justify="space-between" p="10px 0">
          <span>Flexible End Date</span>
          <span>{format(new Date(data?.FlexibleDateEnd), "dd/MM/yyyy")}<br />
          {format(new Date(data?.FlexibleDateEnd), "hh:mm a")}</span>
        </GridItem>
          </>:<></>
        }
      </Grid>
    })
    set_open(true);
    handleClick();
  }
  const handleEdit = () =>{
    handleClick();
    set_modal({
      header:'Edit ExamPeriod SetUp',
      content:<AddType {...{...data,isEdit:true}}/>
    });
    set_open(true);
    
  }
  const handleDelete = () =>{
    set_modal({
      header:'Delete ExamPeriod SetUp',
      content:<Grid gap="20px">
        <GridItem>Are you Sure you want to delete this ExamPeriod Setup</GridItem>
        <GridItem as={Flex} justify="space-between" p="20px 0">
          <Button disabled={isLoading} onClick={()=>deleteExam()} bg="var(--dark-green-color)"
            color="var(--white-color)" >{isLoading?'Loading':'Delete'}</Button>
          <Button disabled={isLoading} 
            variant="outline" bg="var(--white-color)"
            onClick={()=>set_open(false)}
            border="1px solid var(--dark-green-color)"
            color="var(--dark-green-color)" >Cancel</Button>
        </GridItem>
      </Grid>
    });
    set_open(true);
  }
  
  return (
    <TablePopUp click={handleClick} options={[
      {label:'View Examperiod',click:handleView},
      {label:'Edit ExamPeriod',click:handleEdit},
      // {label:'Delete Examperiod',click:handleDelete}
    ]} />
  )
}
